export default __webpack_public_path__ + "static/media/iPhone X.c4ac03f5.svg";